export type PrizmTimeMode = 'HH:MM' | 'HH:MM:SS' | 'HH:MM:SS.MSS';
